import { init, trackError, trackEvent } from 'services/analytics'
import { graphql, useFragment } from 'react-relay'
import { useEffect } from 'react'
import { analytics_useAnalytics$key } from '__generated__/analytics_useAnalytics.graphql'

export function useTrackEventOnMount(event: string, condition: boolean = true) {
  return useEffect(() => {
    if (condition) trackEvent(event)
  }, [])
}

export function useAnalytics(userFragmentRef: analytics_useAnalytics$key) {
  const user = useFragment(graphql`
    fragment analytics_useAnalytics on User {
      id
      
      ...analytics_init
    }
  `, userFragmentRef)

  useEffect(() => {
    init(user).catch(err => trackError(err, 'low'))
  }, [user?.id])
}
